__turbopack_context__.v({
  "active": "Label-module__o6COTG__active",
  "icon": "Label-module__o6COTG__icon",
  "info": "Label-module__o6COTG__info",
  "license": "Label-module__o6COTG__license",
  "main": "Label-module__o6COTG__main",
  "new": "Label-module__o6COTG__new",
  "recommended": "Label-module__o6COTG__recommended",
});
